import * as angular from 'angular';

import { SignInOptionsComponent } from './sign-in-options.component';
import { SignInOptionsPasswordFormComponent } from './sign-in-options-password-form/sign-in-options-password-form.component';
import { SignInOptionsService } from '~/modules/sign-in/feature-sign-in-options/sign-in-options.service';
import { SignInModule } from '../feature-sign-in/sign-in.module';

/* prettier-ignore */
export const SignInOptionsModule = angular
  .module('sign-in-options', [SignInModule])
  .component('signInOptions', SignInOptionsComponent)
  .component('signInOptionsPasswordForm', SignInOptionsPasswordFormComponent)
  .service('SignInOptionsService', SignInOptionsService)
  .name;
